import type { ReactNode } from 'react';
import './ScreenTransition.css';

interface ScreenTransitionProps {
  type: 'fade' | 'slide' | 'none';
  duration: number;
  isTransitioning: boolean;
  children: ReactNode;
}

/**
 * Handles transition animations between showcase screens.
 *
 * Uses CSS transitions only (no JS animation libraries) to keep the bundle
 * lightweight and maintain 60fps on TV hardware.
 *
 * - fade: opacity 1 → 0 (outgoing), then 0 → 1 (incoming)
 * - slide: translateX(0) → translateX(-100%) then incoming from right
 * - none: instant swap
 */
export default function ScreenTransition({
  type,
  duration,
  isTransitioning,
  children,
}: ScreenTransitionProps) {
  const transitionStyle =
    type === 'none'
      ? undefined
      : {
          transitionDuration: `${duration}ms`,
        };

  const className = [
    'screen-transition',
    `screen-transition--${type}`,
    isTransitioning ? 'screen-transition--out' : 'screen-transition--in',
  ].join(' ');

  return (
    <div className={className} style={transitionStyle}>
      {children}
    </div>
  );
}
